import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Play, ArrowsClockwise, Handshake } from "@phosphor-icons/react";
import { Heading, Stat, Btn } from "./NKDaily";
import LoadedQuestions from "./LoadedQuestions";

export default function SaturdayAdmin() {
  const [state, setState] = useState(null);
  const load = async () => {
    try { const { data } = await api.get("/saturday/state"); setState(data); }
    catch { /* */ }
  };
  useEffect(() => { load(); const id = setInterval(load, 15000); return () => clearInterval(id); }, []);

  const startNow = async () => {
    if (!confirm("Force-start the Saturday Challenge NOW?")) return;
    try { await api.post("/saturday/admin/start-now"); toast.success("Saturday Challenge started"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  const reschedule = async () => {
    try { await api.post("/saturday/admin/schedule"); toast.success("Rescheduled with latest sponsor"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  const show = state?.show;
  return (
    <div className="space-y-6">
      <Heading title="NK Saturday Challenge" subtitle="Sponsored 30-question event. Every Saturday, 7pm UTC. Bigger rewards, special leaderboard." />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <Stat label="State" value={show?.state || "—"} />
        <Stat label="Questions loaded" value={(show?.questions || []).length} />
        <Stat label="Scheduled for" value={show?.scheduled_for ? new Date(show.scheduled_for).toLocaleString() : "—"} mono />
      </div>

      <div className="nk-card p-5 border-nk-gold/30 bg-nk-gold/[0.03]">
        <p className="eyebrow text-nk-gold mb-2 flex items-center gap-2">
          <Handshake size={14} weight="fill" /> Sponsor
        </p>
        {show?.sponsor_name ? (
          <div className="flex items-center gap-4">
            {show.sponsor_logo_url && <img src={show.sponsor_logo_url} alt={show.sponsor_name} className="w-12 h-12 object-contain" />}
            <div>
              <p className="font-display text-xl">{show.sponsor_name}</p>
              <p className="text-xs text-nk-mute mt-0.5">This brand will be shown to every player during the show.</p>
            </div>
          </div>
        ) : (
          <p className="text-sm text-nk-mute">No sponsor wired. Mark a Sponsors row as <b>live</b>, then click "Reschedule" below to refresh.</p>
        )}
      </div>

      <div className="flex flex-wrap gap-2">
        <Btn onClick={startNow} Icon={Play} label="Start now" tone="gold" testid="admin-saturday-start-btn" />
        <Btn onClick={reschedule} Icon={ArrowsClockwise} label="Reschedule (refresh sponsor)" tone="line" />
        <Btn onClick={() => window.open("/saturday", "_blank")} Icon={ArrowsClockwise} label="Open live show" tone="line" />
      </div>

      <div className="nk-card p-4">
        <p className="eyebrow mb-2">Scoring</p>
        <ul className="text-sm text-nk-mute space-y-1 list-disc pl-5">
          <li>+20 Season Score per correct answer (2× NK Daily rate)</li>
          <li>+50 SS bonus to the fastest correct answerer per question</li>
          <li>Special per-show leaderboard preserved for sponsor analytics</li>
          <li>Sponsor view + participant counters auto-increment at show end</li>
        </ul>
      </div>
      <LoadedQuestions mode="saturday" />
    </div>
  );
}
